import { render, staticRenderFns } from "./UnicodeCodec.vue?vue&type=template&id=68ac2685&scoped=true"
import script from "./UnicodeCodec.vue?vue&type=script&lang=js"
export * from "./UnicodeCodec.vue?vue&type=script&lang=js"
import style0 from "./UnicodeCodec.vue?vue&type=style&index=0&id=68ac2685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac2685",
  null
  
)

export default component.exports